export default class Constants {
    static BASE_URL = window.location.protocol + '//' + window.location.host;
    static DEFAULT_COMPANY = 'VNIB';
    static LOCAL_STORAGE = {
        AUTHORIZATION: 'Authorization',
        TOKEN: 'token',
        IS_FORCE_LOGIN: 'isForceLogin',
        BROWSER_ID: 'browserId',
        SELECTED_COMPANY: 'selectedCompany',
        LANGUAGE: 'lang'
    };

    static CONTEXT_STATUS = {
        IDLE: 'IDLE',
        LOADING: 'LOADING',
        SUCCESS: 'SUCCESS',
        FAILED: 'FAILED',
        IS_LOGOUT: 'IS_LOGOUT'
    };

    static EVENT_BUS = {
        HR_CARD_DETAIL: {
            UPDATE_STATUS: 'UPDATE_STATUS'
        },
        HR_COMPANY: {
            UPDATE: 'COMPANY_UPDATE'
        },
        HR_PROFILE: {
            UPDATE: 'PROFILE_UPDATE'
        },
        USER_RESUME: {
            UPDATE_RESUME: 'UPDATE_RESUME'
        }
    };

    static FILTER_OPTION = {
        STATUS: 'status',
        DETAIL_INFO: 'detailInfo',
        REASON_TO_LEAVE: 'reasonToLeave',
        TYPE: 'type',
        OPTION: 'option',
        SEARCH_OPTION: 'searchOption'
    };

    static PURPLE_SELECT_STYLE = {
        palette: {
            purple: {
                main: '#CAADFF',
                contrastText: '#000',
                dark: '#CAADFF',
                light: '#CAADFF'
            }
        }
    };

    static TYPE_STATUS = {
        ALL: 'all',
        REQUEST: 'request',
        DENIED: 'denied',
        POSTING: 'posting',
        PAUSED: 'paused',
        WORKING: 'working',
        SENT: 'sent',
        ACTIVE: 'active',
        DORMANT: 'dormant',
        STOPPED: 'stopped',
        WITHDRAWAL: 'withdrawal',
        DELETED: 'deleted',
        NEW: 'new',
        UNDER_REVIEW: 'under_review',
        CONFIRM: 'confirm',
        NAME: 'name',
        EMAIL: 'email',
        JOB: 'job',
        POSITION: 'position',
        DEPARTMENT: 'department',
        PHONE: 'phone',
        EMPLOYEE_NUMBER: 'employeeNumber'
    };

    static SEARCH_OPTIONS = {
        ALL: 'all',
        TITLE: 'title',
        COMPANY_NAME: 'companyName',
        JOB_POSITION: 'jobPosition',
        NAME: 'name',
        EMAIL: 'email',
        JOB_POSTING_TITLE: 'jobPostingTitle',
        POSTING_WRITER: 'postingWriter',
        POSITION: 'position'
    };

    static ROLE = {
        ADMIN: 'ROLE_ADMIN',
        USER: 'ROLE_USER',
        INVITED_USER: 'ROLE_INVITED_USER',
        SUPER_ADMIN: 'ROLE_SUPER_ADMIN',
        DATA_ADMIN: 'ROLE_DATA_ADMIN',
        TEMPLATE_ADMIN: 'ROLE_TEMPLATE_ADMIN',
        CUSTOMER_ADMIN: 'ROLE_CUSTOMER_ADMIN',
        PAYMENT_ADMIN: 'ROLE_PAYMENT_ADMIN',
        VIEWER: 'ROLE_VIEWER',
        CORPORATE_CUSTOMER: 'ROLE_CORPORATE_CUSTOMER',
        INVITED_HR: 'hr',
        INVITED_JOB: 'job_posting',
        LEAVE_MANAGEMENT: 'leave_management',
        WORK_MANAGEMENT: 'work_management',
        EMPLOYEE_LIST: 'employee_list',
        SHOW_ORGANIZATION: 'showOrganization'
    };

    static WEBSOCKET = {
        SOCKET_FORCE_LOGOUT_CLIENT: 'SOCKET_FORCE_LOGOUT_CLIENT',
        SOCKET_ADVISOR_REQUEST: 'SOCKET_ADVISOR_REQUEST',
        SOCKET_ROLE_UPDATE: 'SOCKET_ROLE_UPDATE',
        SOCKET_JOB_APPLICANT_REQUEST: 'SOCKET_JOB_APPLICANT_REQUEST',
        SOCKET_JOB_POSTING_REQUEST: 'SOCKET_JOB_POSTING_REQUEST'
    };

    static EXCEPTION = {
        ACCOUNT_TYPE: {
            APPLE: 'APPLE',
            GOOGLE: 'GOOGLE'
        },
        ERROR_TYPE: {
            CONFLICT_ACCOUNT_TYPE: 'CONFLICT_ACCOUNT_TYPE',
            CONFLICT_DEVICE_TYPE: 'CONFLICT_DEVICE_TYPE'
        }
    };

    static DEFAULT_PAGE_INFO = { size: 10, number: 1, totalElements: 0, totalPages: 0 };

    static CUSTOM_SCROLL_BAR = {
        '&::-webkit-scrollbar': {
            height: '6px',
            width: '6px',
            border: '1px solid #d5d5d5',
            background: 'gray'
        },
        '&::-webkit-scrollbar-track': {
            backgroundColor: '#f1f1f1'
        },
        '&::-webkit-scrollbar-thumb': {
            backgroundColor: '#C4C1C8',
            borderRadius: 2
        },
        '&::-webkit-scrollbar-thumb:hover': {
            background: '#b0afaf'
        }
    };

    static HR_CARD = {
        STATUS: {
            LEADER: 'Leader',
            SUB_LEADER: 'Sub_Leader',
            EMPLOYEE: 'Employee',
            RESIGNED: 'Resigned'
        }
    };

    static HR_CARD_DETAIL = {
        ADDITIONAL: 'ADDITIONAL',
        BASIC: 'BASIC',
        BUSINESS: 'BUSINESS',
        CAREER: 'CAREER',
        PERSONAL: 'PERSONAL',
        PROJECT: 'PROJECT',
        ROLE_MEMBER: {
            VIEW: 'VIEW',
            EDIT: 'EDIT'
        },
        BUSINESS_FORM: {
            POSITION: {
                FULL_TIME: 'FULL_TIME',
                PART_TIME: 'PART_TIME',
                INTERNSHIP: 'INTERNSHIP',
                APPRENTICE: 'APPRENTICE',
                FREELANCER: 'FREELANCER',
                TEMPORARY: 'TEMPORARY',
                EXTERNAL_PARTNERS: 'EXTERNAL_PARTNERS',
                RESIGNED: 'RESIGNED'
            }
        },
        TOAST_TITLE: {
            ADDITIONAL: 'Additional',
            BASIC: 'Basic',
            BUSINESS: 'Business',
            CAREER: 'Career',
            PERSONAL: 'Personal',
            PROJECT: 'Project'
        }
    };

    static MY_CAREER_CARD = {
        CAREER: 'CAREER',
        CONTACT: 'CONTACT',
        ACHIEVEMENT: 'ACHIEVEMENT',
        INTRODUCTION: 'INTRODUCTION',
        ABILITY: 'ABILITY',
        EXPERIENCE: 'EXPERIENCE',
        EDUCATION: 'EDUCATION'
    };

    static LEAVE_TYPE = {
        ANNUAL: 'ANNUAL',
        EXTRA: 'EXTRA',
        PUBLIC: 'PUBLIC',
        UNPAID: 'UNPAID'
    };

    static RESUME_ATTRIBUTES = {
        NAME_INFO: 'nameInfo',
        BASIC_INFO: 'basicInfo',
        PERSONAL: 'personal',
        BIZ_BUSINESS: 'bizBusiness',
        BUSINESS: 'business',
        EDUCATION: 'education',
        EXPERIENCE: 'experience',
        TRAINING: 'training',
        CERTIFICATE: 'certificate',
        SKILL: 'skill',
        LANGUAGE: 'language',
        OBJECTIVE: 'objective',
        PORTFOLIO: 'portfolio',
        PROJECT: 'project',
        SUMMARY: 'summary',
        WORK_STORY: 'workStory',
        LIFE_STYLE: 'lifeStyle'
    };

    static SHOWING_OPTION = {
        ...Constants.RESUME_ATTRIBUTES,
        ALL: 'All',
        ONLY_KNOWN: 'Only_known',
        NONE: 'None'
    };
}
